import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import Accordion from 'core/components/accordion/Accordion'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Grid from 'core/elements/grid'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import deleteVmStyles from './deleteVmStyles'

const useStyles = makeStyles<Theme>((theme) => ({
  ...deleteVmStyles(theme),
}))

const DeletionStatus = ({ deleted }) => {
  const classes = useStyles()
  return (
    <div>
      <FontAwesomeIcon
        className={clsx(classes.marginRight, deleted ? classes.successText : classes.errorText)}
      >
        {deleted ? 'check' : 'xmark'}
      </FontAwesomeIcon>
      {deleted ? 'Deleted' : 'Failed'}
    </div>
  )
}

const vmDeletionTableColumns = [
  {
    key: 'success',
    label: 'Deletion Status',
    render: (value) => <DeletionStatus deleted={value} />,
  },
  { key: 'vmName', label: 'Name', render: (value, item) => value || item?.vmId },
]

const volumeDeletionTableColumns = [
  {
    key: 'success',
    label: 'Deletion Status',
    render: (value) => <DeletionStatus deleted={value} />,
  },
  { key: 'volumeName', label: 'Name', render: (value, item) => value || item?.volumeId },
]

const portDeletionTableColumns = [
  {
    key: 'success',
    label: 'Deletion Status',
    render: (value) => <DeletionStatus deleted={value} />,
  },
  { key: 'portAddress', label: 'IP Address' },
]

export default function DetailedResults({
  virtualMachines,
  vmVolumes,
  vmPorts,
  allVmSuccess,
  allVolumeSuccess,
  allPortSuccess,
  successfulVmDeletions,
  vmDeletionResults,
  volumesToDelete,
  portsToDelete,
  volumeDeletionResults,
  portDeletionResults,
  failedVmDeletions,
  failedVolumeDeletions,
  failedPortDeletions,
}) {
  const totalNumResources = virtualMachines?.length + vmVolumes?.length + vmPorts?.length
  const totalFailedDeletions =
    failedVmDeletions?.length + failedVolumeDeletions?.length + failedPortDeletions?.length
  const allResourcesSuccess = allVmSuccess && allVolumeSuccess && allPortSuccess

  const classes = useStyles()
  return (
    <div className={classes.detailedContainer}>
      <Text variant="subtitle2">
        {allResourcesSuccess
          ? 'You successfully deleted all the selected resources'
          : `${totalFailedDeletions} of ${totalNumResources} resources weren't deleted due to an error`}
      </Text>
      <div className={classes.detailedDeleteBoxes}>
        <Accordion
          id="detailed-vm-results"
          icon="chevron-down"
          iconRotate={180}
          title={
            <div className={classes.accordionDeleteBox}>
              <FontAwesomeIcon
                className={allVmSuccess ? classes.darkGreenIcon : classes.darkRedIcon}
                solid
              >
                {allVmSuccess ? 'circle-check' : 'circle-xmark'}
              </FontAwesomeIcon>
              <div>
                <Text variant="subtitle2">VMs</Text>
                <Text variant="body2">
                  {successfulVmDeletions?.length} of {virtualMachines?.length} deleted
                </Text>
              </div>
            </div>
          }
        >
          {vmDeletionResults?.length > 0 && (
            <Grid
              uniqueIdentifier="id"
              data={vmDeletionResults}
              columns={vmDeletionTableColumns}
              showItemsCountInLabel={false}
              disableToolbar
            />
          )}
        </Accordion>
        <Accordion
          id="detailed-volume-results"
          icon="chevron-down"
          iconRotate={180}
          title={
            <div className={classes.accordionDeleteBox}>
              <FontAwesomeIcon
                className={allVolumeSuccess ? classes.darkGreenIcon : classes.darkRedIcon}
                solid
              >
                {allVolumeSuccess ? 'circle-check' : 'circle-xmark'}
              </FontAwesomeIcon>
              <div>
                <Text variant="subtitle2">Volumes</Text>
                <Text variant="body2">
                  {volumesToDelete?.length - failedVolumeDeletions?.length} of{' '}
                  {volumesToDelete?.length} deleted
                </Text>
              </div>
            </div>
          }
        >
          {volumeDeletionResults?.length > 0 && (
            <Grid
              uniqueIdentifier="id"
              data={volumeDeletionResults}
              columns={volumeDeletionTableColumns}
              showItemsCountInLabel={false}
              disableToolbar
            />
          )}
        </Accordion>
        <Accordion
          id="detailed-port-results"
          icon="chevron-down"
          iconRotate={180}
          title={
            <div className={classes.accordionDeleteBox}>
              <FontAwesomeIcon
                className={allPortSuccess ? classes.darkGreenIcon : classes.darkRedIcon}
                solid
              >
                {allPortSuccess ? 'circle-check' : 'circle-xmark'}
              </FontAwesomeIcon>
              <div>
                <Text variant="subtitle2">Ports</Text>
                <Text variant="body2">
                  {portsToDelete?.length - failedPortDeletions?.length} of {portsToDelete?.length}{' '}
                  deleted
                </Text>
              </div>
            </div>
          }
        >
          {portDeletionResults?.length > 0 && (
            <Grid
              uniqueIdentifier="id"
              data={portDeletionResults}
              columns={portDeletionTableColumns}
              showItemsCountInLabel={false}
              disableToolbar
            />
          )}
        </Accordion>
      </div>
    </div>
  )
}
